<template>
  <v-card>
    <Edit :editDialog="editDialog" :task="selectedTask" @close="editClose" />
    <v-toolbar class="elevation-0" height="45" color="gray">
      <v-toolbar-title style="width: 100%;">
        <h1 class="subheading">{{ task.length }} {{ $t("pageHeader.pendingTasks") }}</h1>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-select
        :items="users"
        clearable
        v-model="selectedUser"
        solo
        item-text="fullName"
        return-object
        label="Select User"
      ></v-select>
    </v-toolbar>
    <v-card-text v-if="isLoading">
      <v-progress-linear
        size="50"
        width="7"
        indeterminate="indeterminate"
        color="pink"
      ></v-progress-linear>
    </v-card-text>
    <div v-else>
      <v-list class="list-800" two-line v-if="task.length !== 0">
        <template v-for="(row, index) in task">
          <v-list-tile ripple hover @click="$router.push({ path: `/task/profile/${row.id}` })">
            <v-list-tile-avatar>
              <img
                class="br-50"
                v-if="row.assignedToUser.imageUrl"
                :src="row.assignedToUser.imageUrl"
                alt="User"
              />
              <img class="br-50" v-else src="../../../assets/images/user.jpeg" alt="User" />
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>
                <div class="font-weight-medium">
                  <span v-if="row.assignedToUser && row.assignedToUser.fullName">
                    {{ row.assignedToUser.fullName }}
                  </span>
                  <!-- <span class="green--text">{{ row.title }}</span> -->
                </div>
              </v-list-tile-title>
              <v-list-tile-sub-title class="text--primary text-overflow">
                <span class="green--text">{{ row.title }}</span>
              </v-list-tile-sub-title>
              <v-list-tile-sub-title class="text-overflow">{{
                row.description
              }}</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <div class="caption">{{ row.createdAt | moment("from", "now") }}</div>
              <div v-if="row.dueDate" class="caption red--text">
                <v-icon small color="red">mdi-calendar-blank-outline</v-icon>
                {{ row.dueDate | moment("from", "now") }}
              </div>
              <div class="caption">{{ row.reporterUser.fullName }}</div>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider v-if="index + 1 < task.length" :key="index"></v-divider>
        </template>
      </v-list>
      <v-card-text v-else>
        <div class="text-xs-center title font-weight-regular">No task for now!</div>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
const Edit = () => import("../components/Edit");
import taskService from "../service.js";
import userService from "../../User/service.js";
import "vue-status-indicator/styles.css";

export default {
  data() {
    return {
      selectedTask: {},
      editDialog: false,
      task: [],
      users: [],
      selectedUser: {},
      isLoading: true
    };
  },
  mounted() {
    this.getAll();
    this.getAllCrmUser();
    this.$events.listen("refresh-task", data => this.getAll());
  },
  components: {
    Edit
  },
  watch: {
    selectedUser(val) {
      if (val) {
        this.getByUserId(this.selectedUser.userID);
      } else {
        this.getAll();
      }
    }
  },
  methods: {
    editClose() {
      this.selectedTask = {};
      this.editDialog = !this.editDialog;
    },
    getAllCrmUser(data) {
      return userService.getAllCrmUser(data).then(result => {
        console.log("user list", result);
        this.users = result.data;
      });
    },
    editTask(row) {
      this.selectedTask = row;
      this.editDialog = !this.editDialog;
    },
    getByUserId(id) {
      this.isLoading = true;
      return taskService
        .getByUserId(id)
        .then(result => {
          console.log("task", result);
          this.task = result.data;
          this.isLoading = false;
        })
        .catch(err => {
          console.log("err on getting user", err);
        });
    },
    getAll() {
      return taskService
        .getTaskList()
        .then(result => {
          console.log("task", result);
          this.task = result.data;
          this.isLoading = false;
        })
        .catch(err => {
          console.log("err on getting user", err);
        });
    }
  }
};
</script>

<style scoped>
.list-800 {
  max-height: 800px;
  overflow: auto;
}
.text-overflow {
  white-space: nowrap;
  width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
